import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { CONTACT } from "../lib/data";
import { trackContact } from "../lib/fb";

export const WhatsAppButton = () => (
  <motion.a
    href={CONTACT.whatsappHref}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    onClick={trackContact}
    aria-label="Chat on WhatsApp"
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.4 }}
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-black border border-black px-5 py-4 font-mono text-xs uppercase tracking-widest hover:bg-black hover:text-[#25D366] transition-colors duration-200"
  >
    <MessageCircle size={18} />
    <span className="hidden sm:inline">WhatsApp us</span>
  </motion.a>
);
